import { Component, input } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { Order } from '../order.model';
import { IconComponent } from '../../../shared/icon/icon.component';

@Component({
  selector: 'app-order-properties',
  standalone: true,
  imports: [CurrencyPipe, IconComponent],
  templateUrl: './order-properties.component.html',
  styleUrls: ['./order-properties.component.css']
})
export class OrderPropertiesComponent {
  order = input.required<Order>();

  // Helper method to safely get discount price
  getDiscountPrice(): number {
    const currentOrder = this.order();
    return currentOrder.promotion?.discountPrice ?? 0;
  }
}